import React from 'react';
import config from 'config';
import { GBAddress } from 'src/components/ConfirmIdentityForm/GBAddress';
import { USAddress } from 'src/components/ConfirmIdentityForm/USAddress';
import { AUAddress } from 'src/components/ConfirmIdentityForm/AUAddress';
import PersonalIdNumberContainer from 'src/containers/forms/PersonalIdNumberContainer';
import SSNLastFourContainer from 'src/containers/forms/SSNLastFourContainer';
import StripeVerificationDocumentContainer from 'src/containers/forms/StripeVerificationDocumentContainer';
import sortBy from 'lodash/sortBy';

export const countryAddressFields: { [key: string]: any } = {
  GB: GBAddress,
  US: USAddress,
  AU: AUAddress,
};

export const countryCodes: { [key: string]: string } = {
  GB: 'United Kingdom',
  US: 'United States',
  AU: 'Australia',
};

export const supportedCountries = sortBy(
  config.ENABLED_COUNTRIES.map(countryCode => ({
    value: countryCode,
    label: countryCodes[countryCode],
  })),
  ['label']
);

type VirtualAccountRequiredFieldProps = {
  onSubmit: () => void;
};

export const stripeVirtualAccountRequiredFieldsMap: {
  [key: string]:
    | any
    | React.ComponentClass<VirtualAccountRequiredFieldProps>
    | React.StatelessComponent<VirtualAccountRequiredFieldProps>;
} = {
  'legal_entity.ssn_last_4': SSNLastFourContainer,
  'legal_entity.personal_id_number': PersonalIdNumberContainer,
  'legal_entity.verification.document': StripeVerificationDocumentContainer,
};

export const stripeVirtualAccountRequiredFields = Object.keys(
  stripeVirtualAccountRequiredFieldsMap
).map(requiredField => requiredField);



// WEBPACK FOOTER //
// ./src/helpers/stripe.tsx